import { Component } from '@angular/core';
import { AdminModule } from '../admin.module';

@Component({
  selector: 'app-projects-page',
  standalone: true,
  imports: [AdminModule],
  templateUrl: './projects-page.component.html',
  styleUrl: './projects-page.component.css'
})
export class ProjectsPageComponent {

}
